export default {

	cache:{},
}